// extracted by mini-css-extract-plugin
export var labelWrapper = "_gd-0";